export const DAYSMAPPINGS = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
export const LOCALES = [{value: 'fr', label: 'Français'}, {value: 'nl', label: 'Dutch'}, {value: 'en', label: 'English'}];
